// Psychologist/Favorites/FavoriteButton.tsx

import React, {useContext, useState} from 'react';
import {axios} from 'Auth/axiosConfig';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {IPsychologist} from '../../../Types/psychology/psychologist';
import {CircularProgress, IconButton} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import {useTheme} from 'Theme/ThemeContext';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import {FavoritesContext} from "Psychologist/Favorites/FavoritesContext";

interface FavoriteButtonProps {
    psychologist: IPsychologist;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({psychologist}) => {
    const {plt} = useTheme();
    const {byResponse} = useErrorProcessing();
    const [loading, setLoading] = useState(false);
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;
    const {isFavorite, toggleFavorite} = useContext(FavoritesContext);

    const isFavoritePsychologist = isFavorite(psychologist.id);

    const handleToggleFavorite = async () => {
        if (loading) return;
        setLoading(true);
        try {
            if (isFavoritePsychologist) {
                if (isAuthenticated) {
                    await axios.post('/api/v1/psychologists/favorites/remove/', {psychologist_id: psychologist.id});
                }
                toggleFavorite(psychologist.id);
            } else {
                if (isAuthenticated) {
                    await axios.post('/api/v1/psychologists/favorites/add/', {psychologist_id: psychologist.id});
                }
                toggleFavorite(psychologist.id);
            }
        } catch (error) {
            byResponse(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <IconButton onClick={handleToggleFavorite} color="inherit" disabled={loading}>
            {loading ? (
                <CircularProgress size={24}/>
            ) : isFavoritePsychologist ? (
                <FavoriteIcon color="error"/>
            ) : (
                <FavoriteBorderIcon style={{color: plt.text.primary70}}/>
            )}
        </IconButton>
    );
};

export default FavoriteButton;
